import {Routes} from '@angular/router';
import {TaskManagerSupportListComponent} from '@features/task-manager/components/task-manager-ticket-list/task-manager-support-list-component';
import {TaskManagerSupportKanbanComponent} from '@features/task-manager/components/task-manager-kanban/task-manager-support-kanban-component';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import { TaskComponent } from '@features/task-manager/components/task/task.component';
import {GenerateTokenComponent} from '../../development-only/generate-token/generate-token.component';
import {DevEnvGuard} from '@core/services/dev-env-guard.service';

export const supportRoutes: Routes = [
  {
    path: '',
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'dashboard',
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'generate-token',
    component:  GenerateTokenComponent,
    canActivate: [DevEnvGuard]
  },
  {
    path     : 'support-configuration',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'task-manager/support/grid',
    component: PlatformLinkCreatorComponent,
  },
  {
    path     : 'task-manager/support/grid/:taskId',
    component: TaskManagerSupportListComponent
  },
  {
    path     : 'task-manager/support/card',
    component: PlatformLinkCreatorComponent
  },
  {
    path     : 'task-manager/support/card/:id',
    component: TaskManagerSupportKanbanComponent
  },
  {
    path     : 'ticket/:taskId',
    component: TaskComponent
  },
  {
    path     : ':taskId',
    component: PlatformLinkCreatorComponent
  }
];

